export const getErrors = () => ({ app: state }) => state.errors;
export const getToasts = () => ({ app: state }) => state.toasts.items;
export const getMenuState = () => ({ app: state }) => state.menu;
export const getUsersMenuState = () => ({ app: state }) => state.menuUsers;
export const getChatsMenuState = () => ({ app: state }) => state.menuChats;
export const getCurrentStream = () => ({ app: state }) => state.stream.currentStream;
export const getSoundsToPlay = () => ({ app: state }) => state.sounds;
export const getEstadoSonido = () => ({ app: state }) => state.config.sonidoActivo;
export const getEstadoDarkMode = () => ({ app: state }) => state.config.darkMode;
export const getEstadoContactosRefresh = () => ({ app: state }) => state.config.contactsRefresh;
export const getEstadoAdvertenciaCiere = () => ({ app: state }) => state.config.close_warning;
export const getIsLoggedFB = () => ({ app: state }) => state.config.loggedInFB;
export const getAccessToken = () => ({ app: state }) => state.config.access_token;
